const API_URL = "http://localhost:8081/";
// const API_URL = "http://192.168.1.35:8081/";
const API_SERVER = process.env.NODE_ENV === "production" ? process.env.REACT_APP_API_URL : API_URL;

export default API_SERVER;
